<div id="header" >
    <div class="navbar">
        <!-- <a href="javascript:void(0);"><img src="../../../assets/images/logo-empresa.jpg"></a> -->
         <h2>{{empresa}}</h2>
         <div class="search-bar" [formGroup]="headerForm">
              <div class="search-container">
                  <input class="form-control" formControlName="searchControl" type="text" (keydown.enter)="searchClick()" placeholder="Pesquisar no RealDesk">
                  <!-- Mensagem ao lado do input -->
                  <div *ngIf="isSearchControlNotEmpty()" class="search-message" [@slideInOut]>
                      Digite Enter para realizar a busca
                  </div>
              </div>
              <!-- Lista de resultados -->
              <div *ngIf="searchResults?.length && showResults" class="search-results">
                  <ul>
                      <li *ngFor="let item of searchResults" 
                          [routerLink]="['/tickets', item.IdTicket, 'edit']"
                          (click)="showResults = false">
                          <div class="ticket-item">
                              <div><strong>#{{item.IdTicket}}</strong></div>
                              <div class="ticket-subject">Assunto: {{item.Assunto}}</div>
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
    </div>

    <div id="infos-right">
        <div class="language-dropdown">
            <button class="dropdown-toggle" (click)="toggleDropdown()">
              <img
                [src]="getFlag(currentLanguage)"
                alt="{{ currentLanguage }}"
                class="flag-icon"
              />
              {{ getLanguageName(currentLanguage) }}
            </button>
            <ul class="dropdown-menu" *ngIf="dropdownOpen">
              <li
                *ngFor="let lang of languages"
                (click)="selectLanguage(lang.code)"
                [class.active]="lang.code === currentLanguage"
              >
                <img [src]="lang.flag" alt="{{ lang.name }}" class="flag-icon" />
                {{ lang.name }}
              </li>
            </ul>
          </div>    

        <div class="avatar"  matTooltip="{{nomeOperador}}-{{rolesUsuario}}" (click)="toggleMenu()">
            <img src="../../../assets/images/avatar.png">
            <span class="status offline" *ngIf="!isOnline"></span>
            <span class="status online" *ngIf="isOnline"></span>
        </div>
        <div [@slideToggle]="menuState" class="menu-options">
            <a href="javascript:void()" (click)="stayOnline()" *ngIf="!isOnline" class="menu-item">
              <fa-icon [icon]="faWifi"></fa-icon>
              <span>Ficar Online</span>
              <fa-icon [icon]="faCircle" class="status-dot" style="color: #28a745;"></fa-icon>
            </a>
            <a href="javascript:void()" (click)="stayOffline()" *ngIf="isOnline" class="menu-item">
              <fa-icon [icon]="faPowerOff"></fa-icon>
              <span>Ficar Offline</span>
              <fa-icon [icon]="faCircle" class="status-dot" style="color: #6c757d;"></fa-icon>
            </a>
            <a href="javascript:void()" (click)="verFilaAtendimento()" class="menu-item">
              <fa-icon [icon]="faUserGroup"></fa-icon>
              <span>Fila de atendimento</span>
            </a>
            <a href="javascript:void()" (click)="profile()" class="menu-item">
              <fa-icon [icon]="faUserGear"></fa-icon>
              <span>Perfil</span>
            </a>
            <a href="javascript:void()" (click)="logOut()" class="menu-item">
              <fa-icon [icon]="faRightFromBracket"></fa-icon>
              <span>Sair</span>
            </a>
        </div>
    </div>
</div>